import React, { useState } from 'react';

/**
 * Displays a single team member's report with expand/collapse.
 * Props: member (object from /api/leader/team-reports members array)
 */
const MemberReportCard = ({ member, onViewHistory }) => {
  const [expanded, setExpanded] = useState(false);

  const statusConfig = {
    submitted: { label: 'Submitted', className: 'bg-green-100 text-green-800' },
    locked:    { label: 'Locked',    className: 'bg-blue-100 text-blue-800' },
    draft:     { label: 'Draft',     className: 'bg-yellow-100 text-yellow-800' },
    null:      { label: 'Not submitted', className: 'bg-red-100 text-red-800' }
  };

  const statusKey = member.status || null;
  const status = statusConfig[statusKey] || statusConfig[null];
  const hasReport = !!member.report_id;

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden">
      {/* Header row */}
      <div className="flex items-center justify-between p-4 bg-white hover:bg-gray-50">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 font-bold flex-shrink-0">
            {member.full_name.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <p className="font-medium text-gray-900 truncate">{member.full_name}</p>
            <p className="text-xs text-gray-500 truncate">{member.email}</p>
          </div>
          {!member.is_required && (
            <span className="ml-1 text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded flex-shrink-0">
              Optional
            </span>
          )}
        </div>

        <div className="flex items-center gap-2 flex-shrink-0 ml-4">
          <span className={`text-xs font-medium px-2 py-1 rounded-full ${status.className}`}>
            {status.label}
          </span>

          {hasReport && (
            <button
              onClick={() => setExpanded(e => !e)}
              className="text-sm text-blue-600 hover:underline px-2"
            >
              {expanded ? 'Hide' : 'View'}
            </button>
          )}

          <button
            onClick={() => onViewHistory(member)}
            className="text-sm text-gray-500 hover:text-gray-800 px-2"
            title="View history"
          >
            History
          </button>
        </div>
      </div>

      {/* Expanded report content */}
      {expanded && hasReport && (
        <div className="border-t border-gray-100 bg-gray-50 p-4 grid md:grid-cols-2 gap-4">
          <div>
            <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2">Yesterday</h4>
            <pre className="whitespace-pre-wrap text-sm text-gray-800 font-sans">
              {member.yesterday_text || <span className="italic text-gray-400">No content</span>}
            </pre>
          </div>
          <div>
            <h4 className="text-xs font-semibold text-gray-500 uppercase mb-2">Today</h4>
            <pre className="whitespace-pre-wrap text-sm text-gray-800 font-sans">
              {member.today_text || <span className="italic text-gray-400">No content</span>}
            </pre>
          </div>
          {member.submitted_at && (
            <p className="md:col-span-2 text-xs text-gray-400">
              Submitted at: {new Date(member.submitted_at).toLocaleString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' })}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default MemberReportCard;
